var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('manage-password',{attrs:{"title":_vm.$translate('user_profile')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }